import HeaderList from "../../components/HeaderList"
import { PageProps } from '../../components/types'
import DataGrid from 'react-data-grid'
import { PicklistReturnColumn } from '../../constants/Column'

import { useCallback, useMemo, useState } from "react";

import usePicklistReturn from '../../hooks/usePicklistReturn'
import { DgtPdOrderPicklist, ExtraReturnStatus } from "../../models"
import { formatDateFromUnix, formatDateObject } from "../../utilities/Format";
import { writeFile, utils } from 'xlsx';

const PicklistReturn = ({ title, division, from, to }: PageProps) => {
  const [status, setStatus] = useState<ExtraReturnStatus>(ExtraReturnStatus.NEW)
  const [dateRange, setDateRange] = useState<[Date, Date]>([from || new Date(), to || new Date()]);
  const [keyword, setKeyword] = useState<string>('')

  const picklistReturns = usePicklistReturn(status, dateRange[0], dateRange[1], keyword)

  const filterChanged = useCallback((
    key: string, value: string, dateRange?: [Date, Date], values?: string[]) => {
    switch(key) {
      case 'Status':
        const sts = values![0] as ExtraReturnStatus
        return setStatus(sts)
      case 'Released Date Range':
        return setDateRange(dateRange!)
      case 'Search':
        return setKeyword(value)
      default:
        break
    }
  }, [])

  const coupleStatuses = useMemo(() => [
    ExtraReturnStatus.NEW, ExtraReturnStatus.APPROVED, ExtraReturnStatus.CANCELED
  ], [])

  const sortedItems = useMemo(() => {
    if (status === ExtraReturnStatus.APPROVED) {
      const cloneItems = [...picklistReturns]
      cloneItems.sort((a, b) => (b.approvedDateTime || 0) > (a.approvedDateTime || 0) ? 1 : -1)
      return cloneItems
    }
    return picklistReturns
  }, [ picklistReturns, status ])

  const exportFile = useCallback((type: string) => {
    if (type === 'Excel') {
      const wb = utils.book_new();
      
      const ws = utils.json_to_sheet(sortedItems.map(row => {
        const orderInfo: DgtPdOrderPicklist = JSON.parse(row.orderInfo)
        return {
          'Order Id.': row.orderId,
          'Return Id.': row.id,
          'Material Code': orderInfo.materialCode,
          'Material Desc': orderInfo.materialDescription,
          'Returned by': row.requestedBy,
          'Returned Date': formatDateFromUnix(row.requestedDateTime),
          'Received by': row.approvedBy,
          'Received Date': formatDateFromUnix(row.approvedDateTime),
          'Header Text': row.remark,
          'Material Doc Year.': row.documentYear ? row.documentYear : '-',
          'Material Doc No.': row.documentNo ? row.documentNo : '-',
        }
      }))
      ws["!cols"] = [
        { wch: 10 },
        { wch: 40 },
        { wch: 15 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 }
      ];
      utils.book_append_sheet(wb, ws, 'Order Return');

      const formattedDateStart = formatDateObject(dateRange[0])
      const formattedDateEnd = formatDateObject(dateRange[1])
      const exportDates = formattedDateStart === formattedDateEnd ? 
        formattedDateStart : `${formattedDateStart}_${formattedDateEnd}`
      writeFile(wb, `order_return_${status}_${exportDates}.xlsx`);
    }
  }, [ sortedItems, dateRange, status ])

  return <div className="page-container">
    <HeaderList title={title} subTitle={`แผนก : ${division}`}
      orderType={''}
      filterType={false}
      statuses={[status]}
      dateRange={dateRange}
      keywordSearch={keyword}
      coupleStatuses={coupleStatuses}
      filterChanged={filterChanged}
      isAllOrderType={true}
      isExport={true}
      onExportAs={exportFile}
    />
    <DataGrid
      className="mt-4"
      style={{ height: "100%", contain: "none" }}
      columns={PicklistReturnColumn}
      rows={sortedItems}
      defaultColumnOptions={{ resizable: true }}
      rowHeight={55}
    />
  </div>
}

export default PicklistReturn